import { render } from "./ColleagueRegistration.vue?vue&type=template&id=0d17f99a&scoped=true"
import script from "./ColleagueRegistration.vue?vue&type=script&lang=js"
export * from "./ColleagueRegistration.vue?vue&type=script&lang=js"

import "./ColleagueRegistration.vue?vue&type=style&index=0&id=0d17f99a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d17f99a"]])

export default __exports__